import { Grid } from '@mui/material';
import React from 'react';
import CircularIndeterminate from '../../../common/CircularLoading';
import Table from '../../../common/Table';
import { APP_ROUTES } from '../../../common/constants/Routes';
import AddIcon from '@mui/icons-material/Add';
import CustomButton from '../../../common/ui/CustomButton';
import { useNavigate } from 'react-router-dom';
import Header from '../../../common/Header';
import { fuelType } from '../../../common/constants/dropDownList';
import { GridColDef } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
function Fuel() {
  const { t } = useTranslation();
  const loading = false;
  const navigate = useNavigate();
  const columns: GridColDef[] = [
    {
      headerName: t('TANK'),
      field: 'tank_serai_no',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('BRANCH'),
      field: 'branch',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('TANK_CAPACITY'),
      field: 'tank_capacity',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },

    {
      headerName: t('ENTERY_DATE'),
      field: 'entry_date',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      renderCell: ({ row }: any) =>
        fuelType.find(
          (data: any) => Number(data.Code) === Number(row?.dispenser_type)
        )?.Category,
    },
    {
      headerName: t('DIPREADING'),
      field: 'dip_reading',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('DENSITY'),
      field: 'density',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('AVAILABLE_FUEL'),
      field: 'stock_fuel',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('NEWLY_FILLED_FUEL'),
      field: 'new_stock',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('CURRENT_CAPACITY'),
      field: 'current_stock',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('TANK_EMPTY'),
      field: 'ullage',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },
    {
      headerName: t('FILLED_PERSON'),
      field: 'filled_person',
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
    },

    {
      headerName: t('ACTION'),
      field: 'Action',
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      renderCell: ({ row }: any) => {
        const handleEditClick = () => {
          navigate(APP_ROUTES.EDITFUEL, {
            state: { data: { data: row, type: 'edit' } },
          });
        };

        const handleViewClick = () => {
          navigate(APP_ROUTES.VIEWFUEL, {
            state: { data: { data: row, type: 'view' } },
          });
        };

        return (
          <>
            {' '}
            <CustomButton
              text={t('VIEW')}
              className='mx-3'
              color={'secondary'}
              onClick={handleViewClick}
            />
            <CustomButton
              text={t('EDIT')}
              className='mx-3 '
              onClick={handleEditClick}
            />
          </>
        );
      },
    },
  ];
  const data: any[] = [
    {
      id: 'a96907cd-1072-40c8-977e-9f8140962f35',
      branch: 'Elango',
      bunk_details_id: 1,
      tank_id: '4',
      tank_type: 1,
      tank_capacity: '10000',
      entry_date: '2024-08-10',
      stock_fuel: '2000',
      new_stock: '70000',
      current_stock: '90000',
      ullage: '1000',
      user_id: '1',
      filled_person: 'Elango',
      tank_serai_no: 'PEOO1',
      dip_reading: '10.20',
      density: '200',
    },
    {
      id: '6b2e5c12-d322-4a2e-804e-4cc19186f099',
      branch: 'Elango',
      bunk_details_id: 1,
      tank_id: '1',
      tank_type: 1,
      tank_capacity: '10000',
      entry_date: '2024-08-10',
      stock_fuel: '2000',
      new_stock: '70000',
      current_stock: '90000',
      ullage: '1000',
      user_id: '2',
      filled_person: 'Elango',
      tank_serai_no: 'PEOO1',
      dip_reading: '10.30',
      density: '200',
    },
    {
      id: '3',
      branch: 'Elango',
      bunk_details_id: 1,
      tank_id: '2',
      tank_type: 1,
      tank_capacity: '10000',
      entry_date: '2024-08-10',
      stock_fuel: '2000',
      new_stock: '70000',
      current_stock: '90000',
      ullage: '1000',
      user_id: '3',
      filled_person: 'Elango',
      tank_serai_no: 'PEOO1',
      dip_reading: '11.20',
      density: '200',
    },
    {
      id: '4',
      branch: 'Elango',
      bunk_details_id: 1,
      tank_id: '3',
      tank_type: 1,
      tank_capacity: '10000',
      entry_date: '2024-08-10',
      stock_fuel: '2000',
      new_stock: '70000',
      current_stock: '90000',
      ullage: '1000',
      user_id: '4',
      filled_person: 'Elango',
      tank_serai_no: 'PEOO1',
      dip_reading: '10.30',
      density: '200',
    },
  ];
  return (
    <Grid container mb={5}>
      <Grid xs={12} p={2}>
        <Header
          view={true}
          header={t('FUEL')}
          buttonName={t('ADD_FUEL')}
          route={APP_ROUTES.ADDFUEL}
          buttonIcon={AddIcon}
        />
      </Grid>
      {loading ? (
        <Grid xs={12} my={5} display={'flex'} justifyContent={'center'}>
          <CircularIndeterminate />
        </Grid>
      ) : (
        <Grid xs={12} mb={5}>
          <Table
            // totalRecords={
            //   petitionTypeCount
            //     ? petitionTypeCount
            //     : petetionList?.totalRecords || 0
            // }
            rows={data}
            columns={columns}
            // handlePagination={handlePagination}
            // paginationModel={{
            //   page: Number(petetionList?.currentPage) - 1 || 0,
            //   pageSize: Number(petetionList?.pagesize) || 5,
            // }}
            rowHeight={60}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default Fuel;
